// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uYPV","left":"styles_left__3Aoq0"};